import { ChevronDown } from 'lucide-react'
import type { StudioTemplate } from '@/lib/api'

const TEMPLATES: { id: StudioTemplate; name: string; description: string }[] = [
  { id: 'professional_report', name: 'Professional Report', description: 'Full report with cover page, TOC, charts, and branded formatting' },
  { id: 'executive_brief', name: 'Executive Brief', description: 'Concise 2-3 page summary with key metrics highlighted' },
  { id: 'technical_document', name: 'Technical Document', description: 'Detailed technical document with diagrams and code blocks' },
  { id: 'proposal', name: 'Business Proposal', description: 'Client-facing proposal with value proposition and ROI charts' },
  { id: 'blog', name: 'Blog Post', description: 'Engaging article with conversational tone and pull quotes' },
  { id: 'white_paper', name: 'White Paper', description: 'Authoritative deep-dive with research citations and data tables' },
  { id: 'ebook', name: 'E-Book', description: 'Chapter-structured book with narrative flow' },
  { id: 'email', name: 'Email Template', description: 'Professional email with clear CTA and scannable structure' },
]

interface Props {
  selected: StudioTemplate | null
  onSelect: (template: StudioTemplate) => void
}

export function StudioTemplateSelector({ selected, onSelect }: Props) {
  const current = TEMPLATES.find(t => t.id === selected)

  return (
    <div className="relative">
      <div className="relative">
        <select
          value={selected || ''}
          onChange={(e) => onSelect(e.target.value as StudioTemplate)}
          className="w-full appearance-none rounded-lg border border-gray-200 dark:border-white/10 bg-white dark:bg-surface-800 px-4 py-2.5 pr-10 text-sm font-medium text-gray-900 dark:text-white cursor-pointer hover:border-gray-300 dark:hover:border-white/20 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
        >
          {TEMPLATES.map((tmpl) => (
            <option key={tmpl.id} value={tmpl.id}>
              {tmpl.name}
            </option>
          ))}
        </select>
        <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none" />
      </div>
      {current && (
        <p className="mt-1.5 text-xs text-gray-500 dark:text-gray-400">
          {current.description}
        </p>
      )}
    </div>
  )
}
